export const FACELEAK_PROFILES = [
  {
    id: 'tom',
    name: 'Tom Anders',
    handle: 'tomanders',
    age: 32,
    location: 'Los Angeles, CA',
    network: 'West Coast Creators',
    relationship: 'Single',
    occupation: 'Site Admin',
    status: 'Doing late-night maintenance. Message board cleanup in progress.',
    tagline: 'First friend since day one.',
    memberSince: 'July 2004',
    lastLogin: 'Today, 5:14 PM',
    profileViews: 129440,
    friendCount: 4821,
    avatar: '/faceleak/avatars/tomanders.png',
    about:
      'Built this place on stale coffee and ISP coupons. If the site is slow tonight, the photo server is being re-indexed again.',
    interests: {
      general: 'Community software, garage-sale speakers, long help threads',
      music: 'Talking Heads, The Cure, The Cars',
      movies: 'Office Space, WarGames, Back to the Future',
      books: 'Small web business handbooks, PC Magazine back issues',
    },
    favoriteMusic: ['The Cure - Just Like Heaven', 'New Order - Bizarre Love Triangle', 'A-ha - Take On Me'],
    favoriteMovies: ['Sneakers', 'High Fidelity', 'Ghostbusters'],
    topFriends: ['lena', 'brad1995', 'jules'],
    photos: [
      {
        id: 'tom-event',
        title: 'College station reunion',
        src: '/faceleak/photos/tom_reunion.png',
        date: 'Jan 2007',
      },
    ],
    memes: [
      {
        id: 'tom-nerd-meme-1',
        title: 'Nerd Meme: Stack Trace Poetry',
        src: '/faceleak/memes/nerd_stacktrace.png',
        caption: 'When the bug disappears as soon as Tom stands behind you.',
      },
    ],
    videos: [
      {
        id: 'vid-1',
        title: 'Rick Astley - Never Gonna Give You Up',
        youtubeId: 'dQw4w9WgXcQ',
        note: 'Posted in Web Classics group',
      },
      {
        id: 'vid-2',
        title: 'Chocolate Rain Man Weeps Into Camera',
        youtubeId: 'EwTZ2xpQwpA',
        note: 'From Staff Picks archive',
      },
    ],
    wall: [
      {
        id: 'w1',
        author: 'LenaM',
        date: 'Mar 14, 2007 8:12 PM',
        text: 'Tom, the photo upload is back. Thanks for fixing that timeout bug.',
      },
      {
        id: 'w2',
        author: 'Brad1995',
        date: 'Mar 14, 2007 4:06 PM',
        text: 'Your old links page still has my skate clip. legend.',
      },
    ],
  },
  {
    id: 'brad1995',
    name: 'Brad K.',
    handle: 'brad1995',
    age: 19,
    location: 'Cedar Rapids, IA',
    network: 'Midwest Tech College',
    relationship: 'It\'s Complicated',
    occupation: 'Campus AV Desk',
    status: 'lab till 10, then halo2 custom maps',
    tagline: 'Burning mix CDs since 2003.',
    memberSince: 'October 2005',
    lastLogin: 'Today, 5:39 PM',
    profileViews: 8422,
    friendCount: 387,
    avatar: '/faceleak/avatars/brad1995.png',
    about:
      'Mostly on after class. If I do not answer, I am probably rewiring the dorm router or helping someone clean spyware again.',
    interests: {
      general: 'LAN nights, thrift-store keyboards, car stereos',
      music: 'Weezer, Blink-182, Taking Back Sunday',
      movies: 'The Matrix, Ocean\'s Eleven, Superbad trailers',
      books: 'GamePro, old Maximum PC issues',
    },
    favoriteMusic: ['Blink-182 - Always', 'Jimmy Eat World - The Middle', 'The Killers - Mr. Brightside'],
    favoriteMovies: ['The Matrix Reloaded', 'School of Rock', 'Napoleon Dynamite'],
    topFriends: ['tom', 'lena', 'jules'],
    photos: [
      {
        id: 'brad-1',
        title: 'Dorm desk setup',
        src: '/faceleak/photos/brad_desk.png',
        date: 'Feb 2007',
      },
    ],
    memes: [
      {
        id: 'brad-troll-meme-1',
        title: 'Troll Meme: Forum Reply Guy',
        src: '/faceleak/memes/troll_reply_guy.png',
        caption: 'Posts “source?” and vanishes before anyone can answer.',
      },
    ],
    videos: [
      {
        id: 'vid-3',
        title: 'Rick Astley - Never Gonna Give You Up',
        youtubeId: 'dQw4w9WgXcQ',
        note: 'sent this to everyone in class. nobody saw it coming.',
      },
    ],
    wall: [
      {
        id: 'w3',
        author: 'Jules_Arcade',
        date: 'Mar 13, 2007 10:02 PM',
        text: 'you still owe me that pinball high score screenshot',
      },
      {
        id: 'w4',
        author: 'Tom Anders',
        date: 'Mar 11, 2007 1:08 PM',
        text: 'Brad, thanks for reporting that broken upload script.',
      },
    ],
  },
  {
    id: 'lena',
    name: 'Lena M.',
    handle: 'lenamedia',
    age: 21,
    location: 'Queens, NY',
    network: 'CUNY Arts',
    relationship: 'Single',
    occupation: 'Photo Lab Assistant',
    status: 'new scans up in my album. be nice.',
    tagline: 'Film camera in one hand, USB cable in the other.',
    memberSince: 'May 2006',
    lastLogin: 'Today, 4:55 PM',
    profileViews: 11009,
    friendCount: 512,
    avatar: '/faceleak/avatars/lenamedia.png',
    about:
      'I scan old prints for classmates and keep everyone\'s event photos organized. If your album is rotated sideways, yes I can fix it.',
    interests: {
      general: 'Street photos, used bookstores, train station people-watching',
      music: 'Yeah Yeah Yeahs, Feist, Camera Obscura',
      movies: 'Amelie, Eternal Sunshine, Lost in Translation',
      books: 'Photo annuals, zines, interview magazines',
    },
    favoriteMusic: ['The Postal Service - Such Great Heights', 'Feist - 1234', 'Phoenix - If I Ever Feel Better'],
    favoriteMovies: ['Amelie', 'Garden State', 'Almost Famous'],
    topFriends: ['tom', 'jules', 'brad1995'],
    photos: [
      {
        id: 'lena-1',
        title: 'Subway platform, 7AM',
        src: '/faceleak/photos/lena_subway.png',
        date: 'Mar 2007',
      },
      {
        id: 'lena-2',
        title: 'Storefront neon',
        src: '/faceleak/photos/lena_neon.png',
        date: 'Dec 2006',
      },
    ],
    memes: [
      {
        id: 'lena-baby-meme-1',
        title: 'Baby Meme: Dial-Up Nap Time',
        src: '/faceleak/memes/baby_dialup_nap.png',
        caption: 'Sleeps through modem tones, wakes up for startup chime.',
      },
    ],
    videos: [
      {
        id: 'vid-4',
        title: 'Keyboard Cat Plays You Off (Sponsor: Cheetos)',
        youtubeId: 'J---aiyznGQ',
        note: 'keyboard cat plays me off during final critiques.',
      },
    ],
    wall: [
      {
        id: 'w5',
        author: 'Brad K.',
        date: 'Mar 14, 2007 2:50 PM',
        text: 'those new scans are clean. what scanner model was that?',
      },
      {
        id: 'w6',
        author: 'Tom Anders',
        date: 'Mar 10, 2007 9:19 PM',
        text: 'featured your city album on the front page this week.',
      },
    ],
  },
  {
    id: 'jules',
    name: 'Jules Arcade',
    handle: 'jules_arcade',
    age: 18,
    location: 'Tacoma, WA',
    network: 'Pacific LAN Club',
    relationship: 'Single',
    occupation: 'Arcade Counter',
    status: 'cabinet repair day. no quarters accepted tonight.',
    tagline: 'CRT glow > everything.',
    memberSince: 'January 2006',
    lastLogin: 'Today, 5:02 PM',
    profileViews: 7304,
    friendCount: 266,
    avatar: '/faceleak/avatars/jules_arcade.png',
    about:
      'I keep old machines alive and post scoreboards every Sunday. This profile is mostly photos of arcade parts and bad pizza slices.',
    interests: {
      general: 'Arcade repairs, thrift electronics, pinball tournaments',
      music: 'Daft Punk, The Prodigy, LCD Soundsystem',
      movies: 'Tron, Scott Pilgrim trailers, The Last Starfighter',
      books: 'Game manuals, strategy guides',
    },
    favoriteMusic: ['Daft Punk - One More Time', 'Justice - D.A.N.C.E.', 'The Prodigy - Firestarter'],
    favoriteMovies: ['Tron', 'Wargames', 'The Last Starfighter'],
    topFriends: ['brad1995', 'lena', 'tom'],
    photos: [
      {
        id: 'jules-2',
        title: 'Closing shift scoreboard',
        src: '/faceleak/photos/jules_scorecard.png',
        date: 'Jan 2007',
      },
    ],
    memes: [
      {
        id: 'jules-nerd-meme-1',
        title: 'Nerd Meme: LAN Party Spreadsheet',
        src: '/faceleak/memes/nerd_lan_sheet.png',
        caption: 'Roster color-coded by ping and snack budget.',
      },
    ],
    videos: [
      {
        id: 'vid-5',
        title: 'Chocolate Rain Man Weeps Into Camera',
        youtubeId: 'EwTZ2xpQwpA',
        note: 'LAN break soundtrack. hits different at 2am.',
      },
    ],
    wall: [
      {
        id: 'w7',
        author: 'Lena M.',
        date: 'Mar 12, 2007 7:01 PM',
        text: 'saved me a machine last night, thank you.',
      },
      {
        id: 'w8',
        author: 'Brad K.',
        date: 'Mar 11, 2007 6:44 PM',
        text: 'still waiting on the winner photo from sunday finals',
      },
    ],
  },
];

export const FACELEAK_NAV_LINKS = [
  'Home',
  'Profile',
  'Messages',
  'Friends',
  'Photos',
  'Groups',
  'Marketplace',
  'Events',
  'Classifieds',
];
